'use strict';

import {log} from './BpmnDebug';

var BpmnConfig = {
    confService: null
};
export default BpmnConfig;

BpmnConfig.setConfService = function(confService){
    log("BpmnConfig.setConfService",confService);
    BpmnConfig.confService = confService;
}
BpmnConfig.getConfService = function(){
    log("BpmnConfig.getConfService",BpmnConfig.confService);
    return BpmnConfig.confService;
}